import { createAction } from 'redux-actions';
import {
  LOAD_USER_LOGIN,
  LOAD_USER_LOGIN_SSO,
  LOAD_USER_PINCODE,
  LOAD_USER_REGISTER,
  LOAD_USER_IS_LOGGEDIN,
  LOAD_USER_MODIFY,
  LOAD_USER_AUTH_HBO_SSO,
  LOAD_USER_AUTH_TOOLBOX,
  LOAD_USER_FACEBOOK,
} from './constants';

export const actionUserPhone = createAction(
  LOAD_USER_LOGIN_SSO.ACTION,
  pin => pin,
  () => ({ thunk: true }),
);
export const pendingUserPhone = createAction(LOAD_USER_LOGIN_SSO.PENDING);
export const successUserPhone = createAction(LOAD_USER_LOGIN_SSO.SUCCESS);
export const errorUserPhone = createAction(LOAD_USER_LOGIN_SSO.ERROR);
export const pinSentUserPhone = createAction(LOAD_USER_LOGIN_SSO.SENT);
export const clearUserLogInSSO = createAction(LOAD_USER_LOGIN_SSO.CLEAR);

export const actionUserPinCode = createAction(
  LOAD_USER_PINCODE.ACTION,
  pin => pin,
  () => ({ thunk: true }),
);
export const pendingUserPinCode = createAction(LOAD_USER_PINCODE.PENDING);
export const errorUserPinCode = createAction(LOAD_USER_LOGIN_SSO.ERROR);

export const actionUserRegister = createAction(LOAD_USER_REGISTER.ACTION);
export const pendingUserRegister = createAction(LOAD_USER_REGISTER.PENDING);
export const successUserRegister = createAction(LOAD_USER_REGISTER.SUCCESS);
export const errorUserRegister = createAction(LOAD_USER_REGISTER.ERROR);

export const actionUserIsLoggedIn = createAction(LOAD_USER_IS_LOGGEDIN.ACTION);
export const pendingUserIsLoggedIn = createAction(
  LOAD_USER_IS_LOGGEDIN.PENDING,
);
export const successUserIsLoggedIn = createAction(
  LOAD_USER_IS_LOGGEDIN.SUCCESS,
);
export const errorUserIsLoggedIn = createAction(LOAD_USER_IS_LOGGEDIN.ERROR);

export const actionUserLogInEmail = createAction(LOAD_USER_LOGIN.ACTION);
export const pendingUserLogInEmail = createAction(LOAD_USER_LOGIN.PENDING);
export const successUserLogInEmail = createAction(LOAD_USER_LOGIN.SUCCESS);
export const errorUserLogInEmail = createAction(LOAD_USER_LOGIN.ERROR);

export const actionUserModify = createAction(LOAD_USER_MODIFY.ACTION);
export const pendingUserModify = createAction(LOAD_USER_MODIFY.PENDING);
export const successUserModify = createAction(LOAD_USER_MODIFY.SUCCESS);
export const errorUserModify = createAction(LOAD_USER_MODIFY.ERROR);

export const actionAuthHboSso = createAction(LOAD_USER_AUTH_HBO_SSO.ACTION);
export const pendingAuthHboSso = createAction(LOAD_USER_AUTH_HBO_SSO.PENDING);
export const successAuthHboSso = createAction(LOAD_USER_AUTH_HBO_SSO.SUCCESS);
export const errorAuthHboSso = createAction(LOAD_USER_AUTH_HBO_SSO.ERROR);

export const actionAuthToolBox = createAction(LOAD_USER_AUTH_TOOLBOX.ACTION);
export const pendingAuthToolBox = createAction(LOAD_USER_AUTH_TOOLBOX.PENDING);
export const successAuthToolBox = createAction(LOAD_USER_AUTH_TOOLBOX.SUCCESS);
export const errorAuthToolBox = createAction(LOAD_USER_AUTH_TOOLBOX.ERROR);

export const actionFacebook = createAction(
  LOAD_USER_FACEBOOK.ACTION,
  pin => pin,
  () => ({ thunk: true }),
);
export const pendingFacebook = createAction(LOAD_USER_FACEBOOK.PENDING);
export const errorFacebook = createAction(LOAD_USER_FACEBOOK.ERROR);
